import React from "react";
import {
  SortableContainer,
  SortableElement,
  SortEndHandler,
} from "react-sortable-hoc";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@material-ui/core";
import { GeneralFeaturedCompetitions } from "./generalTabFeaturedCompetitions";
import "./style.css"
import { COMPETITION_TYPE_ENUM } from "./FeaturedCompetitions";

interface GeneralFeatureCompetitionsTableProps {
  handleSortEnd: SortEndHandler;
  competitionsArr: Array<GeneralFeaturedCompetitions>;
}

export const GeneralFeatureCompetitionsTable: React.FC<GeneralFeatureCompetitionsTableProps> =
  ({ handleSortEnd, competitionsArr }) => {
    const TableBodySortable = SortableContainer(
      ({ children }) => (
        <TableBody tabIndex={0}>{children}</TableBody>
      )
    );

    const Row = SortableElement(({ data, ...other }) => {
      return (
        <TableRow {...other}>
          {Object.keys(data).map((key) => (
            <TableCell>{data[key]}</TableCell>
          ))}
        </TableRow>
      );
    });

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><Typography className="headerCellTxt">#</Typography></TableCell>
            <TableCell><Typography className="headerCellTxt">Title</Typography></TableCell>
            <TableCell><Typography className="headerCellTxt">Competition type</Typography></TableCell>
          </TableRow>
        </TableHead>
        <TableBodySortable onSortEnd={handleSortEnd} >
          {competitionsArr.length > 0 &&
            competitionsArr.map((item, index) => (
              <Row
                index={index}
                key={index}
                data={{
                  number: index+1,
                  title: item.title,
                  competitionType: COMPETITION_TYPE_ENUM[item.competitionType],
                }}
              />
            ))}
        </TableBodySortable>
      </Table>
    );
  };
